import React from "react";
import CardDescription from "./CardDescription";
import AppointmentConfirmationRequired from "./AppointmentConfirmationRequired";
import AppointmentConfirmed from "./AppointmentConfirmed";
import Waiting from "./Waiting";
import PicturesUploaded from "./PicturesUploaded";
import AppointmentDeclined from "./AppointmentDeclined";
import ServiceNotification from "./ServiceNotification";
import MissionCompleted from "./MissionCompleted";
import MissionCancelled from "./MissionCancelled";
import NotificationSent from "./NotificationSent";
import JourneyFinishedAbnormally from "./JourneyFinishedAbnormally";
import { UploadPictures as UploadPicturesOldStyle } from "containers/UploadPictures/UploadPicturesOldCard";
import { UploadPictures } from "containers/UploadPictures/UploadPicturesCard";
import MissingParts from "./MissingParts";
import ContractorArrived from "./ContractorArrived";
import ContractorLeaves from "./ContractorLeaves";
import ContractorOnHisWay from "./ContractorOnHisWay";
import MissionExpired from "./MissionExpired";
import MissionCreated from "./MissionCreated";

export const OldCards = {
  APPOINTMENT_CONFIRMATION_REQUIRED: AppointmentConfirmationRequired,
  APPOINTMENT_CONFIRMED: AppointmentConfirmed,
  APPOINTMENT_WITH_RESCHEDULE: props => (
    <AppointmentConfirmed showRescheduleButton enableComments {...props} />
  ),
  WAITING: Waiting,
  PICTURES_UPLOAD_REQUIRED: UploadPicturesOldStyle,
  PICTURE_UPLOADED: PicturesUploaded,
  APPOINTMENT_DECLINED: AppointmentDeclined,
  SERVICE_NOTIFICATION: ServiceNotification,
  SERVICE_NOTIFICATION_WITH_RESCHEDULE: props => (
    <ServiceNotification showRescheduleButton enableComments {...props} />
  ),
  WORK_COMPLETED: MissionCompleted,
  MISSION_CANCELLED: MissionCancelled,
  MISSION_CREATED: MissionCreated,
  NOTIFICATION_SENT: NotificationSent,
  JOURNEY_FINISHED_ABNORMALLY: JourneyFinishedAbnormally,
  MISSING_PARTS: MissingParts,
  ON_SCENE: ContractorArrived,
  CONTRACTOR_LEAVES: ContractorLeaves,
  EN_ROUTE: ContractorOnHisWay,
  MISSION_EXPIRED: MissionExpired
};
export const CardTypesMap = {
  CardDescription: {
    types: [
      "WAITING",
      "APPOINTMENT_DECLINED",
      "WORK_COMPLETED",
      "MISSION_CANCELLED",
      "MISSION_CREATED",
      "NOTIFICATION_SENT",
      "JOURNEY_FINISHED_ABNORMALLY",
      "MISSING_PARTS",
      "ON_SCENE",
      "EN_ROUTE",
      "MISSION_EXPIRED"
    ],
    component: CardDescription
  },
  PicturesUpload: {
    types: ["PICTURES_UPLOAD_REQUIRED"],
    component: UploadPictures
  }
};

export const cardManager = (showOldCards, type) => {
  let selectedCard = OldCards[type];
  if (showOldCards) return selectedCard;
  Object.values(CardTypesMap).forEach(cardType => {
    if (cardType.types.includes(type)) selectedCard = cardType.component;
  });
  return selectedCard;
};
